import React from "react";

const MaulanaAzadNationalFellowshipSchemeContent = () => {
  return (
    <div className="space-y-4 text-[#333333]">
      <section className="space-y-3">
        <h2 className="text-lg font-bold text-[#183967]">
          Maulana Azad National Fellowship Scheme
        </h2>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          National Minorities Development & Finance Corporation has released the
          fellowship stipend of Rs 25.34 Crs to approximately 2000 scholars
          pursuing Ph.D/M.Phil. for the months of October, November, December
          2022, and January 2023 under the Maulana Azad National Fellowship
          (MANF) Scheme of the Ministry of Minority Affairs. The fellowship
          amount has been released for payment requests generated up to January
          2023.
        </p>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          NMDFC has been designated as Implementing Agency and Central Nodal
          Agency (CNA) for the implementation of Maulana Azad National
          Fellowship (MANF) Scheme of the Ministry of Minority Affairs. NMDFC
          will continue to disburse the Fellowships to the existing MANF Fellows
          till the end of their respective tenure, subject to compliance with
          the extant guidelines.
        </p>
        <p className="text-justify text-[15px] font-bold italic leading-[1.75] text-[#d71920]">
          Note: Maulana Azad National Fellowship Scheme has been discontinued
          since 2023. The existing MANF Fellows will continue to receive
          Fellowships till the end of their respective tenure, subject to
          compliance with the extant guidelines.
        </p>
      </section>
    </div>
  );
};

export default MaulanaAzadNationalFellowshipSchemeContent;